import type { Role } from "../model";
import API, { responseOf } from "./base";

export const create = (role: Role): Promise<Role> =>
  responseOf(API.post("/roles", role));

export const get = (roleId: string): Promise<Role> =>
  responseOf(API.get(`/roles/${roleId}`));

export const update = (role: Role): Promise<Role> =>
  responseOf(API.put(`/roles/${role.id}`, role));

export const remove = async (roleId: string): Promise<void> => {
  await API.delete(`/roles/${roleId}`);
};

export const byOrganization = (orgId: string): Promise<Role[]> =>
  responseOf(API.get(`/roles/byOrganization/${orgId}`));

export const byAccountRole = (subjectId: string): Promise<Role[]> =>
  responseOf(API.get(`/roles/byAccountRole/${subjectId}`));

export const byUserIdAndOrganizationId = (
  userId: string,
  organizationId: string,
): Promise<Role[]> =>
  responseOf(
    API.post("/roles/byUserIdAndOrganizationId/", {
      userId,
      organizationId,
    }),
  );

export const assignRole = async (
  roleId: string,
  userId: string,
): Promise<void> => {
  await API.post(`/roles/${roleId}/assign/${userId}`);
};

export const unassignRole = async (
  roleId: string,
  userId: string,
): Promise<void> => {
  await API.post(`/roles/${roleId}/unassign/${userId}`);
};
